import infoGreen from 'assets/images/account-page/info-green.svg';
import savesExportsIcon from 'assets/images/plan-saves-exports.svg';
import leadAutomatorIcon from 'assets/images/plan-lead-automator.svg';
import teamMemberIcon from 'assets/images/plan-team.svg';
import skipTracingIcon from 'assets/images/plan-skip-tracing.svg';
import classNames from "classnames";
import React, { useRef, useEffect } from "react";
import css from "../style.scss";
import { useDispatch, useSelector } from 'react-redux';
import { selectPlanDetails, updateSelectedChooseTierTooltip } from '../../../../data/user';

const MonthlyEliteIncludes = () => {

    const containerRef = useRef(null);

    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();

    const handleTooltipToggle = (tooltipId) => {
        const tooltipComponentId = `monthlyElite-${tooltipId}`;
        dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
    };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);

    return (
        <div className={css.clsInfoPopup} ref={containerRef}>
            <li>
                <img src={savesExportsIcon} className={css.clsIncludesIcon} alt="Monthly Saves & Exports" />
                <b>100,000</b>
                {" "}
                Monthly Saves & Exports
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('saves')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-saves',
                })} style={{ right: '78%', bottom: '89%' }}>
                    <h6 className={css.clsInfoContentTitle}>Saves & Exports <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>PropStream makes it easy to save, export, and organize your real estate leads for effective marketing and outreach. Quickly export your leads to use with other tools and keep your records up to date. Additional saves and exports are available for purchase.</p>
                </div>
            </li>
            <li>
                <img src={teamMemberIcon} className={css.clsIncludesIcon} alt="9 Full Access Team Members Included" />
                9 Full Access Team Members Included
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('team')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-team',
                })} style={{ right: '56%', bottom: '59%' }}>
                    <h6 className={css.clsInfoContentTitle}>Team Members <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>Perfect for medium to large teams. 9 Full Access Team Members included.</p>
                </div>
            </li>
            <li>
                <img src={skipTracingIcon} className={css.clsIncludesIcon} alt="Free Skip Tracing" />
                Free Skip Tracing
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('tracing')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-tracing',
                })} style={{ right: '34%', bottom: '40%' }}>
                    <h6 className={css.clsInfoContentTitle}>Skip Tracing <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>Free Skip Tracing is available to main account holder and helps you uncover phone numbers and emails for your leads, giving you the tools to connect directly and efficiently. Say goodbye to dead ends and hello to new opportunities.</p>
                </div>
            </li>
            <li>
                <img src={leadAutomatorIcon} className={css.clsIncludesIcon} alt="Lead Automator" />
                <b>Lead Automator:</b>
                {" "}
                120,000 Monitored Properties
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('automator')}>
                    <img src={infoGreen} alt="info" />
                </span>
                <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                    [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyElite-automator',
                })} style={{ right: '24%', bottom: '10%' }}>
                    <h6 className={css.clsInfoContentTitle}>Lead Automator <span className={css.clsCloseIcon} onClick={() => handleTooltipToggle('')}>&times;</span></h6>
                    <p className={css.clsInfoContentPara}>Automatically track and get updates on 120,000 properties with custom filters. Lead Automator works for you to identify new leads that match your designated criteria while flagging previously saved leads that no longer do.</p>
                </div>
            </li>
        </div>
    )
}

export default MonthlyEliteIncludes;
